import Immutable from 'immutable';
import { ActionTypes } from './actions';

export const initialState = Immutable.fromJS({});

const setAll = (state, { allFactoryArea }) => {
  if (!allFactoryArea) return state;
  return state.merge({ allFactoryArea });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
];
